import classNames from "classnames"

type CardProps = {
  children: React.ReactNode
  title: string
  className?: string
  variant?: "default" | "dark"
}

const Card: React.FC<CardProps> = ({ children, title, className, variant = "default" }) => {
  const baseStyles = "p-4 shadow-md rounded-md"
  const variantStyles = {
    default: "bg-neutral-50",
    dark: "bg-[#3e5755] text-white"
  }

  return (
    <section title={title} className={classNames(baseStyles, variantStyles[variant], className)}>
      {children}
    </section>
  )
}

export default Card
